export default __webpack_public_path__ + "static/img-media-coindesk-b2f67913666bffd4bd6179a5a0f3ef35.jpg";